/**
 * オンライン薬局の ID。
 *
 * `domain/index.ts` で `export * as Consultation` 経由で公開されるため、
 * 利用側からは `Consultation.OnlinePharmacy.Au` のように参照される。
 *
 * shared_back 側の `OnlinePharmacy` と値・命名を揃えること。
 */
export const OnlinePharmacy = {
    /** 未指定 */
    Unspecified: 0,
    /** au 薬局 */
    Au: 1,
    /** Kiviaq 薬局 */
    Kiviaq: 2,
    /** ヨヤクスリ_Rakuten 薬局 */
    Rakuten: 3,
    /** Ponta 薬局 */
    Ponta: 4,
};
/**
 * オンライン薬局の表示ラベル（日本語）。
 *
 * clinic / CSV など多言語化不要な箇所で利用する。
 * patient は多言語化のため `t("reservationDetail.xxxPharmacyName")` を使用する。
 *
 * 型は `{ [k: number]: string }` として公開し、API から取得した
 * `number | undefined` を直接 index できるようにする。
 * `satisfies Record<OnlinePharmacy, string>` で全列挙値の網羅性を担保する。
 */
export const OnlinePharmacyLabel = {
    [OnlinePharmacy.Unspecified]: "",
    [OnlinePharmacy.Au]: "au薬局",
    [OnlinePharmacy.Kiviaq]: "Kiviaq薬局",
    [OnlinePharmacy.Rakuten]: "ヨヤクスリ薬局",
    [OnlinePharmacy.Ponta]: "Ponta薬局",
};
/**
 * au 薬局との連携中止日時（2026-06-26 18:00 JST）。
 *
 * この時刻以降は au 薬局を新たに選択できないようにする。
 * 既存データ（`onlinePharmacy = 1`）の値は残すため enum / ラベルは保持する。
 */
export const AU_PHARMACY_TERMINATED_AT = new Date("2026-06-26T18:00:00+09:00");
/**
 * au 薬局を選択可能かどうかを返す。
 * 現在時刻が連携中止日時より前であれば `true`。
 */
export const isAuPharmacyAvailable = (now = new Date()) => now < AU_PHARMACY_TERMINATED_AT;
